import * as React from 'react';
import { Menu as AntdMenu, Icon } from 'antd';
import AppRoute from '../../../Core/models/AppRoute';
import { NavLink, withRouter, RouteComponentProps, matchPath } from 'react-router-dom';
import Utility from '../../../Core/Utility';
import logo from '../../../assets/images/logo.svg';
import AuthContext from 'Context/AuthContext';
const SubMenu = AntdMenu.SubMenu;
const MenuItemGroup = AntdMenu.ItemGroup;

export declare type MenuMode =
  | 'vertical'
  | 'vertical-left'
  | 'vertical-right'
  | 'horizontal'
  | 'inline';

export interface Props extends RouteComponentProps {
  children?: React.ReactNode;
  menu: AppRoute[];
  mode?: MenuMode;
  onlySubMenuNavigates?: boolean;
}

export interface State {}

export class AppMenuWithoutRouter extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;

  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  RenderNavLink(menu: AppRoute, fullPath: string = ''): React.ReactNode {
    if (menu.hideInMainMenu) {
      return;
    }

    return (
      <React.Fragment>
            <Icon type={menu.icon || ''} style={{ color: '#F0403D' }}/> {menu.title}
        <NavLink to={fullPath} />
      </React.Fragment>
    );
  }

  RenderChildMenuItems(menuItems: AppRoute[], parentPath: string = ''): React.ReactNode {
    return menuItems.map((menuItem: AppRoute) => this.getMenuItem(menuItem, parentPath));
  }

  getMenuItem(menu: AppRoute, parentPath: string = ''): React.ReactNode {
    // Hide from menu if option is true or it required permission that the user does not have
    const user = this.context.data;
    if (menu.hideInMainMenu || !Utility.HasOperations(user, menu.requiredOperations)) {
      return null;
    }

    const fullPath = Utility.combinePath(parentPath, menu.path as string);

    const clickEvent = () => this.props.history.push(fullPath);

    let Element: any = menu.routes ? SubMenu : AntdMenu.Item;
    const title: any = menu.routes ? this.GetTitle(menu) : menu.title;

    // we are going to spread this object on the menu element to handle to click action
    // if it is a submenu the it should be onTitleClick else, onClick
    let clickHandler: any = menu.routes ? { onTitleClick: clickEvent } : { onClick: clickEvent };
    clickHandler = this.props.onlySubMenuNavigates && menu.routes ? {} : clickHandler;
    // should we show menu
    const path = { path: this.props.match.path, exact: true };
    const showActive = Utility.isPathOrSubpathAMatch(fullPath, path);
    const activeClass = showActive ? 'ant-menu-item-selected' : '';

    // if menu skip, don't show this route, just render the children
    if (menu.skip) {
      return menu.routes
        ? this.RenderChildMenuItems(menu.routes as any, fullPath)
        : this.RenderNavLink(menu, fullPath);
    } else {
      return (
        <Element key={menu.path as string} className={activeClass} title={title} {...clickHandler}>
          {menu.routes
            ? this.RenderChildMenuItems(menu.routes as any, fullPath)
            : this.RenderNavLink(menu, fullPath)}
        </Element>
      );
    }
  }

  GetTitle(menu: AppRoute): any {
    return (
      <React.Fragment>
            <Icon type={menu.icon || ''} style={{ color: '#F0403D'}} /> {menu.title}
      </React.Fragment>
    );
  }

  render() {
    return (
        <AntdMenu style={{ fontWeight:'bold', fontSize: '20px' }} 
        theme="dark"
        overflowedIndicator={<Icon style={{ fontSize: '1.3em' }} type="menu" />}
        mode={this.props.mode}>
        {this.props.menu.map(item => this.getMenuItem(item))}
      </AntdMenu>
    );
  }
}

const AppMenu = withRouter(AppMenuWithoutRouter);
export default AppMenu;



